import { KoobInputSelectField } from '@koob/ui';
import { getNationalityLabel } from '@koob/utils';
import KoobPlaceholder from '../Koob/KoobPlaceholder';
import { useBooking } from 'hooks';

const SelectNationatilyField = ({
  label,
  name,
  placeholder,
  disabled,
  ...props
}) => {
  const { nationalities, nationalitiesLoading } = useBooking();

  return nationalitiesLoading ? (
    <KoobPlaceholder className="h-8 w-full rounded" />
  ) : (
    <KoobInputSelectField
      name={name}
      label={label}
      items={nationalities}
      renderOption={value => value?.label}
      renderValue={value => value?.label ?? getNationalityLabel(value)}
      disabled={disabled}
      placeholder={placeholder}
      {...props}
    />
  );
};

export default SelectNationatilyField;
